import {BoxProps, Flex} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';

interface IProps {
  count: number;
  boxProps?: BoxProps;
}

export const NotificationsBell: FC<IProps> = ({boxProps, count}) => {
  return (
    <Flex
      w="15px"
      h="15px"
      borderRadius="50%"
      bg={colors.pink}
      color={colors.white}
      fontSize="10px"
      fontWeight="bold"
      position="absolute"
      top="-5px"
      right="-5px"
      justifyContent="center"
      alignItems="center"
      {...boxProps}
    >
      {count}
    </Flex>
  );
};
